.body {
  display: grid;
  gap: 13px;
  padding: 22px;
  overflow-y: auto;
}

.field {
  display: grid;
  gap: 6px;
}

.label {
  font-size: 12px;
  font-weight: 600;
  color: var(--ink-2);
}

/* Пояснение к выбранному варианту — например, сколько броней уже идёт по этой версии: цена
   решения, а не украшение. */
.optionHelp {
  font-size: 11.5px;
  line-height: 1.45;
  color: var(--ink-4);
}

.amountRow {
  display: flex;
  align-items: center;
  gap: 9px;
}

.unit {
  flex-shrink: 0;
  font-size: 13px;
  color: var(--ink-3);
}

/* Типовые формулировки — подсказки, а не выбор из списка: причину всегда можно дописать руками. */
.suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.suggestion {
  height: 26px;
  padding: 0 10px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: var(--panel);
  color: var(--ink-2);
  font: inherit;
  font-size: 11.5px;
  cursor: pointer;
}

.suggestion:hover {
  border-color: var(--ink-4);
  color: var(--ink);
}

.suggestion:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}

/* Что уедет вместе с нажатием — менеджер должен видеть, что именно он утверждает. */
.facts {
  margin: 0;
  padding: 9px 11px;
  border-radius: 9px;
  background: var(--sunk);
  font-size: 12px;
  line-height: 1.5;
  color: var(--ink-2);
}

.foot {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  padding: 15px 22px;
  border-top: 1px solid var(--line);
}

/* Отказ и здесь должен выглядеть отказом (3.2): в карточке он окрашен, а в диалоге, где его
   и подтверждают, был неотличим от «Отмена» рядом. Кайма и текст, без заливки — заливать
   тревожным цветом значило бы сделать отказ самым заметным. */
.rejectConfirm {
  color: var(--st-cancel);
  border-color: color-mix(in oklch, var(--st-cancel) 40%, var(--line));
}

.rejectConfirm:hover:not(:disabled) {
  border-color: var(--st-cancel);
}

/* Почему кнопка погашена — видимым текстом: подсказка в `title` не достаётся ни с клавиатуры,
   ни с тача, а пустое поле рядом с мёртвой кнопкой не объясняет ничего. */
.blocked {
  margin: 0;
  font-size: 11.5px;
  line-height: 1.45;
  color: var(--ink-4);
}
